import { extendTheme } from '@montugroup/themes';
import { toolbarClasses } from '@mui/material';
const palette = {
    palette: {
        primary: {
            main: '#47BC8F', // green
            contrastText: '#FFF',
        },
        secondary: {
            main: '#ee981c',
            contrastText: '#FFF',
        },
        info: {
            main: '#e5f6fd',
            dark: '#0288D1',
        },
    },
};
const theme = extendTheme({
    cssVarPrefix: 'legacy-theme',
    spacing: (factor) => `${0.25 * factor}rem`,
    typography: {
        fontFamily: '"Sofia Pro","Roboto","Helvetica","Arial",sans-serif',
        fontWeightBold: 800,
        button: {
            textTransform: 'none',
            fontSize: '1rem',
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
        },
    },
    colorSchemes: {
        light: palette,
        dark: palette,
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: true,
                disableElevation: true,
                disableFocusRipple: true,
                variant: 'contained',
            },
            styleOverrides: {
                root: () => ({
                    fontSize: '1.1rem',
                }),
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '0.325rem',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '1.1rem',
                },
            },
        },
    },
});
/** @deprecated - Use [theme.breakpoints.up('<breakpoint>')] within styled instead */
export const mq = (n) => `@media (min-width: ${theme.breakpoints.values[n]}px)`;
const alternaleafPalette = {
    palette: {
        primary: {
            main: '#300431', // purple
            light: '#8c0c8f',
            contrastText: '#FFF',
        },
        secondary: {
            main: '#ff5d2b',
            dark: '#c42e00',
            contrastText: '#FFF',
        },
        warning: {
            main: '#ff0000',
        },
        background: {
            default: '#ffffff',
        },
    },
};
export const alternaleafTheme = extendTheme({
    cssVarPrefix: 'legacy-alternaleafTheme',
    spacing: (factor) => `${0.25 * factor}rem`,
    typography: {
        fontSize: 16,
        htmlFontSize: 15,
        fontFamily: '"Mier B","Roboto","Helvetica","Arial",sans-serif',
        fontWeightBold: 800,
        button: {
            textTransform: 'none',
            fontSize: '1rem',
        },
        h4: {
            fontSize: 32,
        },
        body1: {
            fontSize: 16,
        },
        body2: {
            fontSize: 14,
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
        },
    },
    colorSchemes: {
        light: alternaleafPalette,
        dark: alternaleafPalette,
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: true,
                disableElevation: true,
                disableFocusRipple: true,
                variant: 'contained',
            },
            styleOverrides: {
                root: ({ ownerState, theme: t }) => ({
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    letterSpacing: '0.0625rem',
                    padding: '0.5rem 1.38rem',
                    ...(ownerState.variant === 'outlined' &&
                        ownerState.color === 'primary' && {
                        borderColor: t.palette.primary.main,
                    }),
                    ...(ownerState.variant === 'outlined' &&
                        ownerState.color === 'secondary' && {
                        borderColor: t.palette.secondary.main,
                    }),
                    ...(ownerState.size === 'small' && {
                        fontSize: '1rem', // TODO: Confirm with the design team
                    }),
                }),
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '0.325rem',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '1.1rem',
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: ({ theme: t }) => ({
                    background: t.palette.grey[50],
                    '& th': {
                        color: t.palette.grey[700],
                    },
                }),
            },
        },
        MuiTableFooter: {
            styleOverrides: {
                root: ({ theme: t }) => ({
                    background: t.palette.grey[50],
                    color: t.palette.grey[700],
                }),
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: ({ theme: t }) => ({
                    color: t.palette.grey[700],
                    [`.${toolbarClasses.root}`]: {
                        // Override mixin 90px
                        height: 'unset',
                    },
                    '& p': {
                        // Override global inherited rule from legacy scss
                        marginBottom: 0,
                    },
                }),
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '1rem',
                },
            },
        },
    },
    mixins: {
        toolbar: {
            height: '90px',
        },
    },
});
/** @deprecated - Use [theme.breakpoints.up('<breakpoint>')] within styled instead */
export const alternaleafMQ = (n) => `@media (min-width: ${theme.breakpoints.values[n]}px)`;
/**
 * The Material UI Sync plugin is generating theme properties with higher css specificity than the
 * `sx` prop styles.
 *
 * Use this only temporarily where required, so that we can easily track and remove this once we
 * figure out full solution.
 *
 * @example
 * ```ts
 * <Button sx={{ p: 99 }} />
 * ```
 *
 * Generates the `sx` customization for padding on the following selector:
 * ```
 * .css-1csjra-MuiButtonBase-root-MuiButton-root
 * ```
 *
 * But the theme overrides the `sx` padding by generating padding on the following selector:
 * ```
 * .css-1csjra-MuiButtonBase-root-MuiButton-root
 * .MuiButton-sizeLarge.MuiButton-containedPrimary
 * :not(.Mui-disabled)
 * :not(.Mui-focusVisible):not(:hover)
 * ```
 *
 * @deprecated - Use sparingly and question why we need to customize our components as often
 */
export const tmpSxSpecificityForce = '!important';
export default theme;
// This is a temp color list for the patient list page, apparently the full implementation is being worked on
export const tempPatientListColors = {
    active: {
        textColor: '#005B00',
        backgroundColor: '#E7FFE7',
    },
    inactive: {
        textColor: '#181B25DE',
        backgroundColor: '#181B250A',
    },
    pending: {
        textColor: '#00528B',
        backgroundColor: '#E6F4FF',
    },
    concession: {
        textColor: '#181B25DE',
        backgroundColor: '#E6EE9C',
    },
    discharged: {
        textColor: '#6C0000',
        backgroundColor: '#F9E6E6',
    },
    default: {
        textColor: '#181B25DE',
        backgroundColor: '#181B250A',
    },
};
//# sourceMappingURL=data:application/json;base64,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